(function(){
  var mask;

  PegasusTemplate.ResizingCanvasState = Em.State.extend({
    hover: Em.K,
    hoverRow: Em.K,
    setup: function(){
      mask = mask || $('<div class="vr-resizing-mask"/>');
      mask.remove().appendTo('.center');
      PegasusTemplate.lookupController('blockOperations').set('content', null);
      PegasusTemplate.lookupController('rowOperations').set('content', null);
    },
    exit: function(){
      this._super.apply(this, arguments);
      mask.remove();
    }
  });
})();
